import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';

@Component({
    'selector': 'app-managerSettings',
    'templateUrl': './managerSettings.page.html',
    'styleUrls': ['./managerSettings.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ManagerSettingsPage extends ViewBasePage implements OnInit, OnDestroy {
    public onDevice = false;
    public debugMode = false;

    constructor(private platform: Platform, injector: Injector) {
        super(injector);
        super.setCurrentView(this.Constants.VIEW_SETTINGS);
    }

    // ngOnInit(): void {
    //     super.ngOnInit();
    //     this.debugMode = this.sessionService.isDebugMode();

    //     // Changing channels must be done on a phone.
    //     // Don't show the channels option if running on a desktop machine
    //     this.onDevice = this.platform.is('cordova');
    // }

    public ionViewWillEnter() {
        super.setCurrentView(this.Constants.VIEW_SETTINGS);
        super.ngOnInit();
        this.debugMode = this.sessionService.isDebugMode();

        // Changing channels must be done on a phone.
        // Don't show the channels option if running on a desktop machine
        this.onDevice = this.platform.is('cordova');
        // this.initMoreMenu()
    }

    public ionViewWillLeave() {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-settings-tour');
    // }

    public onDealershipClick(): void {
        this.router.navigateByUrl('/managerSettings/dealership')
    }

    public onUsersClick(): void {
        this.router.navigateByUrl('/managerSettings/users')
    }

    public onShuttlesClick(): void {
        this.router.navigateByUrl('/managerSettings/shuttles')
    }

    public onServiceAreasClick(): void {
        this.router.navigateByUrl('/managerSettings/serviceAreas')
    }

    public onTicketCreatedClick(): void {
        this.router.navigateByUrl('/managerSettings/ticketCreated')
    }

    public onDropoffAllAboardClick(): void {
        this.router.navigateByUrl('/managerSettings/dropoffAllAboard')
    }

    public onDropoffCompletedClick(): void {
        this.router.navigateByUrl('/managerSettings/dropoffCompleted')
    }

    public onPickupApproachingClick(): void {
        this.router.navigateByUrl('/managerSettings/pickupApproaching')
    }

    public onPickupArrivedClick(): void {
        this.router.navigateByUrl('/managerSettings/pickupArrived')
    }

    public onPickupCompletedClick(): void {
        this.router.navigateByUrl('/managerSettings/pickupCompleted')
    }

    public onCacheLoginCreds(): void {
        this.router.navigateByUrl('/managerSettings/cacheLoginCreds');
    }
}
